import * as yup from 'yup';

export const validationPasswordSchema = yup.object({
    password: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('passwordconfirm'), null], 'Password not matched'),
    passwordconfirm: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('password'), null], 'Password not matched'),
})

export const validationSchema = yup.object({
    username: yup
        .string()
        .required('Required'),
    firstname: yup
        .string()
        .required('Required'),
    lastname: yup
        .string()
        .required('Required'),
    companyname: yup
        .string()
        .required('Required'),
    regno: yup
        .string()
        .required('Required'),
    // secondRegNo: yup
    //     .string()
    //     .required('Required'),
    code: yup
        .string()
        .required('Required'),
    accountcode: yup
        .string()
        .required('Required'),
    email: yup
        .string()
        .email('Enter a valid email')
        .required('Required'),
    taxregistrationno: yup
        .string()
        .required('Required'),
    taxidentityno: yup
        .string()
        .required('Required'),
    // excludeTax: yup.array()
    //     .of(yup.string())
    //     .min(1, "Min 1 selection")
    //     .required('Required'),
    // contactno: yup
    //     .number()
    //     .typeError("Only number")
    //     .required('Required')
    //     .test(
    //         "is-positive",
    //         "Please enter a positive number",
    //         (value) => value >= 0 && 1 / value !== -Infinity),
    status: yup
        .bool()
        .required('Required'),
})

export const initialPasswordValues = {
    password: "",
    passwordconfirm: "",
}

export const initialValues = {
    username: "",
    companyname: "",
    regno: "",
    secondRegNo: "",
    code: "",
    accountcode: "",
    remark: "",
    salesperson: "",

    firstname: "",
    lastname: "",
    contactno: "",
    email: "",

    taxregistrationno: "",
    taxidentityno: "",
    excludeTax: [],

    status: true,
}